import { Collapse, Modal, Space, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, Spin, Radio, Breadcrumb } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest } from "../../axios";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import moment from "moment";
import ViewRFQMaterialDetails from "./ViewRFQMaterialDetails";
import { InfoCircleOutlined } from "@ant-design/icons";
import PRPopUpDetails from "./PRPopUpDetails";
import ViewRFQSteel from "./ViewRFQSteel";
import PRPopUpDetailsForSteel from "./PRPopUpDetailsForSteel";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const ViewRFQDetails = () => {
  const { responseId } = useParams();

  const initialState = {
    currency: 1,
    price_basis: "Firm",
    freight: "Seller's Scope",
    unloading: "Buyer's Scope",
    transport_insurance: "Buyer's Scope",

    remark_deviation: false,
    open_order: false,
    delivery_date: null,
    price_cap: null,
    amount_cap: null,
    timeline_cap: null,
    delivery_start_date: null,
    delivery_end_date: null,
    rfq_due_date: null,
  };
  const [state, setState] = useState(initialState);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const [zoneList, setZoneList] = useState([]);
  const [currencyName, setCurrencyName] = useState([]);
  const [rfqNumber, setRfqNumber] = useState("");
  const [rfqEditId, setRfqEditId] = useState(null);
  const [apiLoading, setapiLoading] = useState(false);
  const [rfqDetails, setRfqDetails] = useState(null);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [RFQMaterialDetails, setRFQMaterialDetails] = useState(null);
  const [RFQMaterialDetails1, setRFQMaterialDetails1] = useState(null);

  const [prNumberList, setPRNumberList] = useState([]);
  const [prNumberHover, setPRNumberHover] = useState(null);
  const [prCreatorHover, setCreatorHover] = useState(null);
  const [statePRDetailsHover, setStatePRDetailsHover] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryName, setCategoryName] = useState(null);
  const [diameterWiseSteel, setDiameterWiseSteel] = useState([]);
  useEffect(() => {
    const rfqGetById = async () => {
      try {
        const fields = [
                'id','rfq_number','pr_city_wise_by_pr_number','city_wise_pr','city_name','site_wise_details','site_name','site_total_quantity','site_total_quantity_by_kg','material_wise_details','material_type_name','is_new_rfq','material_type_uom_name','estimated_material_unit_price','pr_total_quantity','pr_total_quantity_by_kg','pr_total_amount','remark','vendors','name','is_selected_vendor','purchase_requisition_city_by_pr_number','pr_number','pr_creator','is_diameter_wise','data','city_name','site_wise_pr','site_name','pr_material_details','pr_material_type_name','pr_material_type_sub_category','pr_material_type_uom_name','estimated_material_unit_price','remark','pr_material_type_quantity','pr_material_type_quantity_by_kg','steel_sizes','category_tree', 'category_tree_name','purchase_requisition_material_type_name','estimated_material_unit_price','purchase_requisition_material_type_sub_category','unit_of_measurement_name','preferred_unit_of_measurement','material_total_quantity','material_total_quantity_by_kg','amount','remark','site_wise','city_name','material_type_name','site_name','site_wise_total_quantity','site_wise_total_quantity_by_kg','site_wise_total_amount','vendors_data','diameter_wise','diameter_name','quantity','quantity_by_kg','estimated_price','amount', 'rfq_material_details'
              ].join(",");
              const queryParams = new URLSearchParams();
              queryParams.set("fields", fields);
        setapiLoading(true);
        // const apiResponse = await getRequest(`float-rfq/${responseId}/?${queryParams.toString()}`);
        const apiResponse = await getRequest(`float-rfq/${responseId}/`);
              
        if (apiResponse?.data?.success) {
          setPRNumberList(
            apiResponse.data.data.purchase_requisition_city_by_pr_number
          );
          // const rfqDetailsData = apiResponse?.data?.data?.rfq_details[0];
          // setRfqDetails(rfqDetailsData);
          setRFQMaterialDetails(apiResponse.data.data);
          setRFQMaterialDetails1(apiResponse);

          setCategoryName(apiResponse.data.data.category_tree_name);
          setDiameterWiseSteel(
            apiResponse.data.data.purchase_requisition_city_by_pr_number[0]
              .is_diameter_wise
          );
          // setState((prevState) => ({
          //   ...prevState,
          //   currency_name:
          //     apiResponse.data.data.rfq_details[0]?.currency_name === null
          //       ? 1
          //       : apiResponse.data.data.rfq_details[0]?.currency_name,
          //   currency:
          //     apiResponse.data.data.rfq_details[0]?.currency === null
          //       ? 1
          //       : apiResponse.data.data.rfq_details[0]?.currency,
          //   price_basis: apiResponse.data.data.rfq_details[0]?.price_basis,
          //   freight: apiResponse.data.data.rfq_details[0]?.freight,
          //   unloading: apiResponse.data.data.rfq_details[0]?.unloading,
          //   transport_insurance:
          //     apiResponse.data.data.rfq_details[0]?.transport_insurance,
          //   remark_deviation:
          //     apiResponse.data.data.rfq_details[0]?.remark_deviation,
          //   open_order: apiResponse.data.data.rfq_details[0]?.open_order,
          //   delivery_date:
          //     apiResponse.data.data.rfq_details[0]?.delivery_date === null
          //       ? null
          //       : apiResponse.data.data.rfq_details[0]?.delivery_date,
          //   price_cap: apiResponse.data.data.rfq_details[0]?.price_cap,
          //   amount_cap: apiResponse.data.data.rfq_details[0]?.amount_cap,
          //   timeline_cap: apiResponse.data.data.rfq_details[0]?.timeline_cap,
          //   delivery_start_date:
          //     apiResponse.data.data.rfq_details[0]?.delivery_start_date === null
          //       ? null
          //       : apiResponse.data.data.rfq_details[0]?.delivery_start_date,
          //   delivery_end_date:
          //     apiResponse.data.data.rfq_details[0]?.delivery_end_date === null
          //       ? null
          //       : apiResponse.data.data.rfq_details[0]?.delivery_end_date,
          //   rfq_due_date:
          //     apiResponse.data.data.rfq_details[0]?.rfq_due_date === null
          //       ? null
          //       : apiResponse.data.data.rfq_details[0]?.rfq_due_date,
          // }));
          setRfqNumber(apiResponse?.data?.data?.rfq_number);
          // setRfqEditId(rfqDetailsData?.id);
          setapiLoading(false);

          // if (rfqDetailsData?.open_order) {
          //   setShowAdditionalFields(true);
          //   setDeliveryFields(false);
          // } else {
          //   setShowAdditionalFields(false);
          // }

          setapiLoading(false);
        } else {
          ErrorNotificationMsg(t("error_in_rfq_detail"));
          setapiLoading(false);
        }
      } catch (error) {
        console.error("Error fetching RFQ details", error);
        setapiLoading(false);
      }
    };

    if (responseId) {
      rfqGetById();
    }
  }, [responseId, t]);

  useEffect(() => {
    const getZoneList = async () => {
      setLoading(true);

      try {
        const fields = [
          "approval_by_site",
          "id",
          "city_name",
          "site_name",
          "rfq_status",
          "rfq_approval_by",
          "rfq_sent_for_approval_date",
          "rfq_approval_date",
          "approval_time",
        ].join(",");
        const queryParams = new URLSearchParams({ fields });
        let apiResponse = await getRequest(
          `float-rfq/${responseId}/get-rfq-approval-data-by-site/?${queryParams.toString()}`
          // state
        );

        if (apiResponse?.status) {
          setZoneList(apiResponse?.data?.data?.approval_by_site);
          settotalCount(apiResponse?.data?.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_adress_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getZoneList();
  }, []);

  useEffect(() => {
    setapiLoading(true);
    // if (rfqDetails) {
    //   formRef.current?.setFieldsValue({
    //     delivery_date: rfqDetails?.delivery_date
    //       ? moment(rfqDetails.delivery_date, "DD-MM-YYYY")
    //       : null,
    //     currency: rfqDetails?.currency ?? 1,
    //     price_basis: rfqDetails?.price_basis,
    //     freight: rfqDetails?.freight,
    //     unloading: rfqDetails?.unloading,
    //     transport_insurance: rfqDetails?.transport_insurance,
    //     remark_deviation: rfqDetails?.remark_deviation,
    //     open_order: rfqDetails?.open_order,
    //     timeline_cap: rfqDetails?.timeline_cap,
    //     delivery_start_date: rfqDetails?.delivery_start_date
    //       ? moment(rfqDetails.delivery_start_date, "DD-MM-YYYY")
    //       : null,
    //     delivery_end_date: rfqDetails?.delivery_end_date
    //       ? moment(rfqDetails.delivery_end_date, "DD-MM-YYYY")
    //       : null,
    //     rfq_due_date: rfqDetails?.rfq_due_date
    //       ? moment(state.rfq_due_date, "DD-MM-YYYY HH:mm")
    //       : null,
    //     amount_cap: rfqDetails?.amount_cap,
    //     price_cap: rfqDetails?.price_cap,
    //   });
    // }
    setapiLoading(false);
  }, [state]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getCurrency = async (data) => {
    await getRequest("currency/", data).then((response) => {
      setCurrencyName(response.data.results.data);
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "rfq_approval_by" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_approval_by";
    }
    if (sortField === "rfq_approval_by" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_approval_by";
    }
    if (sortField === "rfq_sent_for_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_sent_for_approval_date";
    }
    if (sortField === "rfq_sent_for_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_sent_for_approval_date";
    }
    if (sortField === "rfq_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_approval_date";
    }
    if (sortField === "rfq_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_approval_date";
    }
    if (sortField === "rfq_status" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_status";
    }
    if (sortField === "rfq_status" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_status";
    }

    return sortingEnumKey;
  };

  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showdeliveryFields, setDeliveryFields] = useState(true);
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };
  const columns = [
    {
      title: "City ",
      dataIndex: "city_name",
      key: "city_name",
    },
    {
      title: "Site",
      dataIndex: "site_name",
      key: "site_name",
    },
    {
      title: "Approver",
      dataIndex: "rfq_approval_by",
      key: "rfq_approval_by",
    },
    {
      title: "Status",
      dataIndex: "rfq_status",
      key: "rfq_status",
      render: (text, record) => {
        return text === "Approve" ? "Approved" : text;
      },
    },
    {
      title: "Sent For Approval",
      dataIndex: "rfq_sent_for_approval_date",
      key: "rfq_sent_for_approval_date",
    },
    {
      title: "Approved Date & Time",
      dataIndex: "rfq_approval_date",
      key: "rfq_approval_date",
    },
    {
      title: "Approval Time/Hrs",
      dataIndex: "approval_time",
      key: "approval_time",
    },
  ];

  const handleShowHoveredPRDetails = (prNumber, statePRDetails, creator) => {
    setPRNumberHover(prNumber);
    setCreatorHover(creator);
    setStatePRDetailsHover(statePRDetails);
    showModal();
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> RFQ Details - View </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>RFQ Details - View</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Space>
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="Back"
              label="Back"
              onClick={() => navigate("/request-for-quotation/history")}
            />
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 multitable">
        <SubscriptionNotification />
        <div className="PR-body tbl-collapse" style={{ padding: "0" }}>
          <div className="tablewrp">
            <div
              style={{
                display: "flex",
                gap: "5px",
                padding: "16px 0px 0px 0px",
              }}
            >
              <h5 className="rfq-number new">
                RFQ Number : <span>{rfqNumber}</span>
              </h5>
              <h5
                className="rfq-number new"
                style={{ alignItems: "center", marginLeft: "20px" }}
              >
                PR Number :{" "}
                {prNumberList.map((prNumber, index) => {
                  return (
                    <>
                      <span
                        key={index}
                        onMouseEnter={() => {
                          handleShowHoveredPRDetails(
                            prNumber?.pr_number,
                            prNumber?.data,
                            prNumber?.pr_creator
                          );
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {prNumber?.pr_number}
                        <InfoCircleOutlined
                          style={{
                            color: "#094E8F",
                            marginLeft: "3px",
                            background: "none",
                            paddingRight: "0",
                            padding: "0px",
                          }}
                        />
                      </span>
                    </>
                  );
                })}
              </h5>
            </div>
            <div>
              <Form autoComplete="off" ref={formRef}>
                <>
                  <section className="grid-sec FormSection mt-5">
                    <div className="secsubtitle">RFQ Details</div>
                    <div className="">
                      <Row gutter={[15]}>
                        {/* <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            {t("pl_currency")}
                          </label>
                          <div className="custom-value">
                            {state?.currency_name}
                          </div>
                        </Col> */}
                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            {t("pl_price_basis")}
                          </label>
                          <div className="custom-value">
                            {state?.price_basis}
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            {t("pl_freight")}
                          </label>
                          <div className="custom-value">{state?.freight}</div>
                        </Col>

                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            {t("pl_unloading")}
                          </label>
                          <div className="custom-value">{state?.unloading}</div>
                        </Col>

                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            {t("pl_transist_insurance")}
                          </label>
                          <div className="custom-value">
                            {state.transport_insurance}
                          </div>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={12}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            className="radioitem"
                            name="open_order"
                            label="Open Order"
                          >
                            <Radio.Group value={state?.open_order} disabled>
                              <Radio value={true}>Yes</Radio>
                              <Radio value={false}>No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          className="TextFeild gutter-row"
                        >
                          <label className="custom-label">
                            RFQ BID Due Date & Time
                          </label>
                          <div className="custom-value">
                            {state?.rfq_due_date ? state?.rfq_due_date : null}
                          </div>
                        </Col>

                        {showdeliveryFields && (
                          <Col
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            className="TextFeild gutter-row"
                          >
                            <label className="custom-label">
                              Delivery Date
                            </label>
                            <div className="custom-value">
                              {state?.delivery_date
                                ? state.delivery_date
                                : null}
                            </div>
                          </Col>
                        )}
                        {showAdditionalFields && (
                          <>
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={6}
                              xl={6}
                              className="TextFeild gutter-row"
                            >
                              <label className="custom-label">
                                Amount Cap (₹)
                              </label>
                              <div className="custom-value">
                                ₹ {state?.amount_cap}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              xl={6}
                              className="TextFeild gutter-row"
                            >
                              <label className="custom-label">
                                Delivery Start Date
                              </label>
                              <div className="custom-value">
                                {state.delivery_start_date
                                  ? state.delivery_start_date
                                  : null}
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              xl={6}
                              className="TextFeild gutter-row"
                            >
                              <label className="custom-label">
                                Delivery End Date
                              </label>
                              <div className="custom-value">
                                {state.delivery_end_date
                                  ? state.delivery_end_date
                                  : null}
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                  </section>
                </>
              </Form>
            </div>
            <div className="acc-one">
              <Spin spinning={apiLoading}>
                <div className="secsubtitle">RFQ Material Details</div>
                {categoryName ? (
                  categoryName.toLowerCase() === "cement" || categoryName.toLowerCase().includes("sand") || categoryName.toLowerCase().includes("aggregate") ? (
                    <ViewRFQMaterialDetails
                      RFQMaterialDetails1={RFQMaterialDetails1}
                    />
                  ) : (
                    <ViewRFQSteel RFQMaterialDetails1={RFQMaterialDetails1} />
                  )
                ) : (
                  <Spin />
                  
                )}
              </Spin>

              <Collapse
                className="custom-collapse"
                style={{ marginTop: "20px" }}
                defaultActiveKey={["0"]}
              >
                <div className="secsubtitle">{t("RFQ Approval Status")}</div>
                <div>
                  <Table
                    scroll={{
                      x: 500,
                    }}
                    columns={columns}
                    rowKey={(record) => record.id}
                    dataSource={zoneList}
                    pagination={false}
                    onChange={handleTableChange}
                  />
                </div>
              </Collapse>
            </div>
          </div>
          <div className="btnwrp">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="Back"
              label="Back"
              onClick={() => navigate("/request-for-quotation/history")}
            />
          </div>
        </div>
      </section>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title={
          <div style={{ justifyItems: "center" }}>
            <h5 className="rfq-number new">
              PR Number : <span>{prNumberHover}</span>
              PR Creator : <span>{prCreatorHover}</span>
            </h5>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        keyboard={true}
        width={"90%"}
      >
        {diameterWiseSteel ? (
          <PRPopUpDetailsForSteel prData={statePRDetailsHover} />
        ) : (
          <PRPopUpDetails statePRDetails={statePRDetailsHover} />
        )}
      </Modal>
    </>
  );
};

export default ViewRFQDetails;
